var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHeroku = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2500 2500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2500v2500H0z",
    fill: "#6762a5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1417.5 1969.9v-787.4s51.2-188.4-630.9 77.1c-1.2 3.4-1.2-728.2-1.2-728.2l222.9-1.4v468.7s624-245.8 624 186.4v784.8zm127-1156.2h-236.4c85.1-104 162.1-282.3 162.1-282.3h244.4c.1 0-41.8 116.2-170.1 282.3zM789.4 1968.6v-448.4l224.2 224.2z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeroku, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/heroku.6779b965.svg";
export { ForwardRef as ReactComponent };